<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section v-if="!task || task.taskStatus !== 'SuccessfullyCompleted'">
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Direct Debit Mandate Setup</h1>
                    <p>The below person has been provided as the direct debit authoriser for your company.</p>
                    <p>Click the button below to complete the mandate setup assigning this person as the authoriser.</p>
                    <table>
                    <thead>
                        <tr>
                        <th>Name</th>
                        <th>Job Title</th>
                        <th>Email Address</th>
                        </tr>
                    </thead>
                    <tbody v-if="_directDebitContact">
                    <tr>
                        <td>{{ _directDebitContact.firstName }} {{ _directDebitContact.lastName }}</td>
                        <td>{{ _directDebitContact.jobTitle }}</td>
                        <td>{{ _directDebitContact.email }}</td>
                    </tr>
                    </tbody>
                    </table>

                    <button class="btn btn-primary" @click="signDirectDebitMandate">Complete Mandate</button>
                    <button class="btn btn-secondary" v-if="userType == 'Administrator'" @click="markAsComplete()">Mark as Complete</button>
                </div>
            </div>
        </section>
        <section v-else>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Direct Debit Mandate Setup Complete</h1>
                    <p>The below person has been provided as the direct debit authoriser for your company.</p>
                    <p>The direct debit mandate has now been completed.</p>
                    <table>
                    <thead>
                        <tr>
                        <th>Name</th>
                        <th>Job Title</th>
                        <th>Email Address</th>
                        </tr>
                    </thead>
                    <tbody v-if="_directDebitContact">
                    <tr>
                        <td>{{ _directDebitContact.firstName }} {{ _directDebitContact.lastName }}</td>
                        <td>{{ _directDebitContact.jobTitle }}</td>
                        <td>{{ _directDebitContact.email }}</td>
                    </tr>
                    </tbody>
                    </table>
                    <br/>
                    
                    <button class="btn btn-secondary" @click="router.back()">Return to Home</button>
                </div>
            </div>
        </section>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useClientStore } from '@/stores/client'
import { useGoCardlessStore } from '@/stores/gocardless'
import { getDirectDebitMandateTask, putDirectDebitTask } from '@/services/implementationmanagement.api'
import { postGoCardlessStart } from '@/services/gocardlessmandatemanager.func'
import { splitByCapitals } from '@/helpers/strings'
import { useRouter, useRoute } from 'vue-router'
import { useIdentityStore } from '@/stores/identity';

const identity = useIdentityStore();
const userType = computed(() => identity.type)

const router  = useRouter()
const route = useRoute();
const loaded = ref(true);
const taskId = route.params.taskId 


const error = ref(null)
const task = ref(null)

// Add local variable to set payload to
const _directDebitContact = ref({})

const errorString = 'An error has occurred. Please contact your Qtac account manager.';

const signDirectDebitMandate = async () => {
    try {


        const clientStore = useClientStore()

        if (!_directDebitContact.value) {
            error.value = 'No Direct Debit Authoriser contact found for this client.'
            return
        }

        // Create random 6 digit string
        const sessionToken = Math.floor(100000 + Math.random() * 900000).toString()

        const payload = {
            sessionToken: sessionToken,
            userId: _directDebitContact.value.contactId,
            firstName: _directDebitContact.value.firstName,
            lastName: _directDebitContact.value.lastName,
            companyName: clientStore.name,
            email: _directDebitContact.value.email
        }



        const response = await postGoCardlessStart(payload, taskId)

        if (response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.'
            return false
        }


        // Read the response data
        const redirectFlowId = response.data.billingRequestFlow.redirectUri;
        const authorisationUrl = response.data.billingRequestFlow.authorisationUrl;


        const goCardlessStore = useGoCardlessStore()
        goCardlessStore.setGoCardless({
            redirectFlowId: redirectFlowId,
            sessionToken: sessionToken
        });

        // Use redirect URL to redirect offsite. Do not open new window.
        window.location.href = authorisationUrl;

    } catch (e) {
        error.value = true
    }
}

const markAsComplete = async () => {
    try {
        task.value.taskStatus = "SuccessfullyCompleted";

        const response = await putDirectDebitTask(taskId, task.value);

        if (response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.'
            return false
        }

        router.back();
    } catch (e) {
        error.value = e
    }
}


onMounted(async () => {
    const clientStore = useClientStore()


    // Get the first contact marked as Direct Debit Authoriser
    _directDebitContact.value = clientStore.contacts.find(c => c.isDirectDebitAuthoriser)


    try {
        var directDebitMandateTask = await getDirectDebitMandateTask(taskId);

        if(directDebitMandateTask.status !== 200 || directDebitMandateTask.data === null || directDebitMandateTask.data === undefined) {
            error.value = errorString;
            return null;
        }


        task.value = directDebitMandateTask.data;

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }

loaded.value = true;
})


</script>

